import './appointment-transfer-popup.ajscss';

import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import {
  IAppointment,
  IVisioAppointmentDetail,
  IVisioAppointmentDetailLight,
  IVisioAppointmentTransfer,
} from '@commons/models/appointment';
import { copy, IComponentController, IComponentOptions, ILogService, isDefined } from 'angular';
import { tap } from 'rxjs';

import { AppointmentTargetType, Campaign, Group, InterviewType, Option, Skill, Team } from '@contact/upgrade';

import { IAppointmentDeprecatedService, ModalParamAppointment } from '../../appointment-deprecated.service';
import { AppointmentService } from '../../appointment.service';
import templateUrl from './appointment-transfer-popup.html';

class AppointmentTransferPopupCtrl implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  responseId: string;

  errorSubmited: boolean = false;
  availableSkills: Skill[] = [];
  availableCampaigns: Campaign[] = [];

  interviewType: InterviewType;
  appointment: IVisioAppointmentTransfer;
  idCsr: string;
  loginCsr: string;
  firstnameCsr: string;
  lastnameCsr: string;
  initDone: boolean = false;
  mode: string = 'PHONE';

  public teams: Team[];
  public groups: Group[];
  public csrs: any[];

  constructor(
    private readonly $log: ILogService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private appointmentService: AppointmentService
  ) {}

  get formIsValid(): boolean {
    if (!this.appointment || !this.appointment.comment || !this.appointment.skillList) {
      return false;
    }

    return this.checkTargetIsValid();
  }

  $onInit(): void {
    this.initialize();
  }

  $onDestroy(): void {}

  cancel(): void {
    this.dismiss();
  }

  submitForm(): void {
    // toast is created in service in case of post pone fail
    this.appointmentDeprecatedService.transferAppointment(this.appointment as IVisioAppointmentDetail).then(
      () => {
        // close the popin
        this.close();

        // Refresh the csr appoinment count  (today)
        this.appointmentService.getTodayAppointmentNumber();
      },
      () => {
        this.toastDeprecatedService.alert('agent:toast.appointment_not_postponed');
      }
    );
  }

  private initialize() {
    // read the modal parameter, type of modalParamRecord
    let param: ModalParamAppointment = this.resolve();
    if (isDefined(param)) {
      this.interviewType = InterviewType[param.mode];
      if (this.interviewType === InterviewType.VISIO) {
        this.appointmentDeprecatedService
          .getAppointment(Option.of(param.idAppointment).get())
          .pipe(
            tap((iappointment: IVisioAppointmentDetailLight) => {
              this.appointment = iappointment;
              this.appointmentDeprecatedService.getVisioSkills().then(
                skills => {
                  // we make a copy here because chosen will add attributes on object list but won't reset them if we use the same list
                  // at next open see ODECSCNGACCEPTANCE-7899
                  this.availableSkills = copy(skills);
                  this.initDone = true;
                },
                () => {
                  this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
                }
              );
            })
          )
          .subscribe();
      }
      if (this.interviewType === InterviewType.PHONE && param.idAppointment !== undefined) {
        this.appointmentDeprecatedService
          .getCampaignContactById(Option.of(param.idAppointment).get())
          .pipe(
            tap((iappointment: IAppointment) => {
              this.appointment = { csr: {} } as IVisioAppointmentDetailLight;
              this.appointment.appointmentId = iappointment.idContact;
              if (iappointment.optionalContent) {
                this.appointment.comment = iappointment.optionalContent['CONTEXT_COMMENT'];
              }
              this.appointmentDeprecatedService.getSkills().then(
                skills => {
                  // we make a copy here because chosen will add attributes on object list but won't reset them if we use the same list
                  // at next open see ODECSCNGACCEPTANCE-7899
                  this.availableSkills = copy(skills);
                  this.initDone = true;
                },
                () => {
                  this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
                }
              );
            })
          )
          .subscribe();
      }
    } else {
      this.$log.error('[AppointmentTransferPopupCtrl] missing compulsory modal parameter');
    }
  }

  setAppointmentCsr(_idCsr: string, _loginCsr: string, _firstnameCsr: string, _lastnameCsr: string) {
    if (!!this.appointment) {
      this.appointment.csr.uuid = _idCsr || '';
      this.appointment.csr.login = _loginCsr || '';
      this.appointment.csr.firstName = _firstnameCsr || '';
      this.appointment.csr.lastName = _lastnameCsr || '';
    }
  }

  onTargetChange({ target }) {
    if (!!this.appointment && !!target) {
      this.appointment.skillList = !!target.skills ? target.skills : [];
      this.appointment.targets = [];
      if (!!target.csr && !!target.csr.uuid) {
        this.setAppointmentCsr(target.csr.uuid, target.csr.login, target.csr.firstName, target.csr.lastName);
      } else {
        this.setAppointmentCsr('', '', '', '');
      }
      if (!!target.teams && target.teams.length > 0) {
        this.appointment.targets.push(
          target.teams.map(_team => ({
            uuid: _team.id,
            name: _team.name,
            type: AppointmentTargetType.TEAM,
          }))
        );
      }
      if (!!target.groups && target.groups.length > 0) {
        this.appointment.targets.push(
          target.groups.map(_group => ({
            uuid: _group.id,
            name: _group.name,
            type: AppointmentTargetType.GROUP,
          }))
        );
      }
    }
  }

  checkTargetIsValid(): boolean {
    if (this.interviewType === InterviewType.VISIO && !!this.appointment) {
      if (!this.appointment) return false;
      if (
        (!!this.appointment.csr && !!this.appointment.csr.uuid) ||
        (!!this.appointment.skillList && this.appointment.skillList.length > 0)
      )
        return true;
    }
    if (this.interviewType === InterviewType.PHONE) {
      if (!!this.appointment.csr && !!this.appointment.csr.uuid) return true;
    }
    return false;
  }
}

export class AppointmentTransferPopup implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    resolve: '&',
  };
  controller = ['$log', 'appointmentDeprecatedService', 'toastDeprecatedService', 'appointmentService', AppointmentTransferPopupCtrl];
}

export default 'appointmentTransferPopup';
